<template>
  <div class="pc-container">
    <!-- ========== 顶部导航栏（仅购物车） ========== -->
    <el-header class="header" style="height: 48px;">
      <div class="header-content">
        <div class="left-menu">
          <!-- <img src="../assets/image/shoplogo.png" alt="" style="height:60px"> -->
        </div>
        <div class="right-menu">
          <el-button type="text" @click="toLogin" style="margin: 18px;">供应商合作</el-button>
          <el-button type="text" @click="toLogin" style="margin: 18px;">采购方注册</el-button>
          <el-button type="text" @click="goToOrders" style="margin: 18px;">我的订单</el-button>
          <el-button type="text" @click="goToContracts" style="margin: 18px;">我的合同</el-button>
          <el-button type="text" @click="goToProfile" style="margin: 18px;">我的</el-button>
          <i class="el-icon-switch-button" style="margin: 18px;font-size: 20px;color: #000;" @click="toLogin"></i>
        </div>
      </div>
    </el-header>

    <!-- ========== 新搜索条（Logo + 搜索） ========== -->
    <div class="page-search-bar">
      <div class="logo">
        <img src="../assets/image/llyn.png" alt="logo" style="height:60px;" />
      </div>
      <div class="search-area">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索商品名称"
          size="medium"
          class="search-input"
          @input="onSearchInput"
          clearable
          prefix-icon="el-icon-search"
        >
          <el-button slot="append" icon="el-icon-search" size="mini" @click="goToSearchPage" style="background: green;color: #fff;margin: 0px -18px;">搜索</el-button>
        </el-input>
      </div>
    </div>

    <!-- ========== 公告栏（走马灯） ========== -->
    <div class="notice-bar" v-if="noticeText">
      <i class="el-icon-megaphone"></i>
      <el-carousel :autoplay="true" :interval="3000" trigger="click" height="30px" indicator-position="none" class="notice-carousel">
        <el-carousel-item v-for="(item, index) in noticeText.split(' ')" :key="index">
          <span class="notice-text">{{ item }}</span>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- ========== 3个小卡片（左侧分类 + 中间轮播商品 + 右侧我的卡片） ========== -->
    <div class="stats-cards-wrapper">
      <el-row :gutter="20">
        <!-- ===== 卡片1：商品分类（带二级分类） ===== -->
        <el-col :span="7">
          <div class="stat-card stat-card-0 category-card" >
            <div class="category-tree">
              <div
                v-for="cat in categoryTree"
                :key="cat.id"
                class="category-branch"
              >
              <!--onCategoryClick(cat)         @click="onSubCategoryClick(cat, sub)"-->
                <div class="category-level1" @click="goToSearchPage(cat.id)">
                  <i :class="cat.icon"></i>
                  <span>{{ cat.name }}</span>
                </div>
                <div class="category-level2">
                  <span
                    v-for="sub in cat.children"
                    :key="sub"
                    class="sub-tag"
                    @click="goToSearchPage(cat.id)"
                  >
                    {{ sub }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- ===== 卡片2：多分类轮播商品展示 ===== -->
        <el-col :span="11">
          <div class="stat-card stat-card-goods">
            <div class="goods-card-header">
              <span class="goods-category-title">{{ currentCardGroup.name }}</span>
              <span class="card-dots">
                <span
                  v-for="(g, idx) in cardGroups"
                  :key="g.id"
                  :class="['dot', idx === currentCardIndex ? 'active' : '']"
                  @click="switchCardCategory(idx)"
                ></span>
              </span>
            </div>
            <div
              class="goods-list"
              :key="currentCardIndex"
              v-loading="cardLoading"
              element-loading-text="加载中..."
            >
              <div
                v-for="item in currentCardGoods"
                :key="item.id"
                class="goods-item"
                @click="onGoodsCardClick(item)"
              >
              <!-- style="width:70%" -->
                <img :src="item.image" alt="商品" loading="lazy"  />
                <div class="goods-name">{{ item.name }}</div>
                <div class="goods-price">{{ item.price }}</div>
              </div>
              <div v-if="currentCardGoods.length === 0 && !cardLoading" class="empty-tip">暂无商品</div>
            </div>
          </div>
        </el-col>

        <!-- ===== 卡片3：我的卡片（右侧） ===== -->
        <el-col :span="6">
          <div class="stat-card stat-card-3 my-card">
            <div class="my-avatar">
              <img :src="crmImg ? crmImg : require('@/assets/image/touxiang.png')" alt="头像" />
            </div>
            <div class="my-name">{{ userInfo.nickname }}</div>
            <div class="my-links">
              <div class="link-item" @click="goToOrders">
                <i class="el-icon-document"></i>
                <span>我的订单</span>
              </div>
              <div class="link-item" @click="goToContracts">
                <i class="el-icon-document-copy"></i>
                <span>我的合同</span>
              </div>
              <div class="link-item" @click="goToProfile">
                <i class="el-icon-user"></i>
                <span>个人中心</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- ========== 2个大卡片（促销活动 / 特色专区） - 动态轮播图 ========== -->
    <div class="promo-cards-wrapper">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(card, idx) in promoCards" :key="idx">
          <div class="promo-card" @click="onPromoClick(card)">
            <el-carousel
              :autoplay="true"
              :interval="3000"
              height="180px"
              indicator-position="none"
              class="promo-carousel"
            >
              <el-carousel-item v-for="(item, index) in card.images" :key="index">
                <img :src="item.img" class="promo-bg-img" />
              </el-carousel-item>
            </el-carousel>
            <div class="promo-overlay">
              <div class="promo-tag">{{ card.tag }}</div>
              <h3 class="promo-title">{{ card.title }}</h3>
              <p class="promo-desc">{{ card.desc }}</p>
              <el-button
                type="primary"
                size="small"
                class="promo-btn"
                @click.stop="onPromoClick(card)"
              >
                {{ card.btnText }}
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- ========== 类目商品tab（分类导航 + 轮播图 + 商品列表） ========== -->
    <div class="category-tab-wrapper">
      <!-- <div class="banner-wrapper" v-if="bannerList.length">
        <el-carousel height="320px" :interval="4000" arrow="always">
          <el-carousel-item v-for="(banner, idx) in bannerList" :key="idx" @click.native="onBannerClick(banner)">
            <img :src="banner.img" class="banner-img" />
          </el-carousel-item>
        </el-carousel>
      </div> -->
      <div class="category-nav">
        <div class="category-scroll">
          <span
            v-for="cat in categoryList"
            :key="cat.id"
            :class="['category-item', activeCategory===cat.id?'active':'']"
            @click="selectCategory(cat)"
          >
            {{ cat.comlist_v1 || cat.bfenlei4 }}
          </span>
        </div>
      </div>
      <div class="goods-section">
        <div class="section-title">
          <span>{{ activeCategoryName }}商品</span>
          <span class="sub-title">为您推荐</span>
        </div>
        <el-row :gutter="20" v-loading="loading">
          <el-col :span="4" v-for="good in goodsList" :key="good.goods_data.id" style="margin-bottom:20px;">
            <el-card :body-style="{ padding: '10px' }" shadow="hover" class="goods-card" @click.native="showGoodsDetailpage(good)">
              <div class="goods-img-wrapper">
                <img :src="good.goods_data.comlist_v8" class="goods-img" />
                <span class="new-tag" v-if="good.goods_data.is_new || true">最新</span>
              </div>
              <div class="goods-info">
                <div class="goods-title">{{ good.goods_data.comlist_v1 }}</div>
                <div class="goods-tags">
                  <span v-for="(lab, idx) in good.goods_data.labels" :key="idx" class="tag">{{ lab }}</span>
                </div>
                <div class="goods-price">{{ good.mx_data[0].comlist_f2 }}</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div v-if="goodsList.length === 0 && !loading" class="empty-tip">暂无相关商品</div>
      </div>
    </div>

    <!-- ================================================================ -->
    <!-- ========== 商品详情 Dialog（左侧滚动 + 右侧固定） ============= -->
    <!-- ================================================================ -->
    <el-dialog
      :visible.sync="showGoodsDetailLayer"
      width="80%"
      top="5vh"
      @close="hideGoodsDetail"
      :close-on-click-modal="true"
      class="goods-detail-dialog"
    >
      <div class="detail-body" v-if="currentGoodsDetail.id">
        <!-- 左右布局：左侧滚动，右侧固定 -->
        <div class="detail-layout">
          <!-- ===== 左侧滚动区 ===== -->
          <div class="detail-left scrollable">
            <!-- 轮播图 -->
            <el-carousel height="400px" indicator-position="outside" v-if="getFilteredMediaList(currentGoodsDetail.comlist_m1).length">
              <el-carousel-item v-for="(media, idx) in getFilteredMediaList(currentGoodsDetail.comlist_m1)" :key="idx">
                <img :src="media" class="detail-img" v-if="isImage(media)" />
                <video v-else-if="isVideo(media)" :src="media" controls style="width:100%;height:400px;" />
              </el-carousel-item>
            </el-carousel>

            <!-- 动态商品详情内容 -->
            <div class="detail-content">
              <div class="goods-detail-section" v-if="pageContentList.length">
                <h3>货品详情</h3>
                <div class="dynamic-content-wrapper">
                  <div
                    v-for="(item, index) in pageContentList"
                    :key="index"
                    class="content-item"
                    :class="'content-' + item.type"
                  >
                    <div v-if="item.type === 'text'" class="text-item" @click="copyText(item.content)">
                      <div class="text-content">{{ item.content }}</div>
                      <el-button type="text" size="mini" class="copy-hint">
                        <i class="el-icon-document-copy"></i> 点击复制
                      </el-button>
                    </div>

                    <div v-else-if="item.type === 'bigImage'" class="image-item big-image" @click="saveImage(item.content)">
                      <img :src="item.content" alt="商品图片" loading="lazy" />
                      <div class="image-hint">
                        <i class="el-icon-download"></i> 点击保存图片
                      </div>
                    </div>

                    <div v-else-if="item.type === 'smallImage'" class="image-item small-image" @click="saveImage(item.content)">
                      <img :src="item.content" alt="商品图片" loading="lazy" />
                      <div class="image-hint">
                        <i class="el-icon-download"></i>
                      </div>
                    </div>

                    <div v-else-if="item.type === 'video'" class="video-item">
                      <video :src="item.content" controls class="content-video"></video>
                      <div class="video-actions">
                        <el-button size="small" type="primary" @click="saveVideo(item.content)">
                          <i class="el-icon-download"></i> 保存视频
                        </el-button>
                      </div>
                    </div>

                    <div v-else-if="item.type === 'tag'" class="tag-item">
                      <span v-if="typeof item.content === 'string'" class="tag tag-primary">
                        {{ item.content }}
                      </span>
                      <template v-else-if="Array.isArray(item.content)">
                        <span
                          v-for="(tag, idx) in item.content"
                          :key="idx"
                          class="tag"
                          :class="{
                            'tag-primary': idx % 3 === 0,
                            'tag-success': idx % 3 === 1,
                            'tag-warning': idx % 3 === 2
                          }"
                        >
                          {{ tag }}
                        </span>
                      </template>
                      <span
                        v-else-if="typeof item.content === 'object' && item.content.text"
                        class="tag"
                        :style="{
                          backgroundColor: item.content.backgroundColor || '#01582B',
                          color: item.content.color || '#fff',
                          border: item.content.border || 'none'
                        }"
                      >
                        {{ item.content.text }}
                      </span>
                      <span v-else class="tag">标签</span>
                    </div>

                    <div v-else class="unknown-item">
                      <el-alert type="warning" :closable="false" show-icon>
                        <template slot="title">
                          未知内容类型: {{ item.type }}
                        </template>
                      </el-alert>
                    </div>
                  </div>
                </div>
              </div>

              <div class="price-note-section">
                <h4>价格说明</h4>
                <ul>
                  <li>1. 标价为单品售价，多规格商品不同规格/配置价格存在差异，选中规格后显示实付价；</li>
                  <li>2. 划线原价为商品挂牌指导价，成交价以结算页为准；</li>
                  <li>3. 运费以下单结算页面展示金额为准，包邮商品满足条件即免运费；</li>
                  <li>4. 优惠券、满减等优惠仅限活动有效期内使用。</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- ===== 右侧固定区（商品信息 + 购买 + 二维码） ===== -->
          <div class="detail-right sticky">
            <div class="detail-info">
              <h2>{{ currentGoodsDetail.name }}</h2>
              <div class="detail-price">{{ currentGoodsDetail.currentPrice }}</div>

              <!-- 规格展示 -->
              <div class="detail-specs" v-if="currentGoodsDetail.mx_list && currentGoodsDetail.mx_list.length">
                <div class="spec-label">可选规格：</div>
                <div class="spec-items">
                  <el-tag
                    v-for="(spec, index) in currentGoodsDetail.mx_list"
                    :key="index"
                    size="medium"
                    :type="spec.comlist_s1 > 0 ? 'success' : 'info'"
                    effect="plain"
                    class="spec-tag"
                  >
                    {{ spec.comlist_v1 || '标准' }} ¥{{ spec.comlist_f2 }}
                    <span class="spec-stock">(库存{{ spec.comlist_s1 }})</span>
                  </el-tag>
                </div>
              </div>

              <div class="detail-stock">库存：{{ currentGoodsDetail.comlist_s1 || 0 }}</div>

              <div class="shop-info" v-if="currentGoodsDetail.sh_id">
                <img :src="currentGoodsDetail.sh_img || '/static/default_shop.png'" class="shop-logo" />
                <span class="shop-name">{{ currentGoodsDetail.sh_name || '店铺' }}</span>
              </div>
                 <div class="purchase-tip">
                <span class="tip-text">本页面仅展示商品信息，规格选择、下单选购请扫码前往微信小程序操作</span>
              </div>
                <!-- 扫码按钮 -->
                <div style="margin: 12px 0;">
                  <el-button
                    type="primary"
                    plain
                    @click="openQRCodeDialog"
                    style="width:100%; color:#fff;background-color: #07c160;"
                  >
                    <i class="el-icon-mobile-phone"></i> 扫码前往小程序选购
                  </el-button>
                </div>

              <div style="margin-top:12px;">
                <!-- <el-button type="danger" :disabled="currentGoodsDetail.comlist_s1 <= 0" @click="openPurchaseLayer">
                  去购买
                </el-button>
                <el-button v-if="currentGoodsDetail.comlist_s1 <= 0" disabled>已售罄</el-button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- ========== 购买 Dialog ========== -->
    <el-dialog
      :visible.sync="showPurchaseLayer"
      width="500px"
      @close="hidePurchaseLayer"
      :close-on-click-modal="true"
      title="购买"
    >
      <div class="purchase-body" v-if="currentGoodsDetail.id">
        <div class="purchase-goods">
          <img :src="currentGoodsDetail.image" class="purchase-img" />
          <div>
            <div class="purchase-name">{{ currentGoodsDetail.name }}</div>
            <div class="purchase-price">{{ currentPurchasePrice }}</div>
          </div>
        </div>
        <div class="spec-section" v-if="currentGoodsDetail.mx_list && currentGoodsDetail.mx_list.length">
          <div class="spec-title">选择规格</div>
          <el-radio-group v-model="currentSpecIndex" size="small" @change="initPurchaseQuantityBySpec">
            <el-radio-button
              v-for="(spec, index) in currentGoodsDetail.mx_list"
              :key="index"
              :label="index"
              :disabled="spec.comlist_s1 <= 0"
            >
              {{ spec.comlist_v1 || '标准' }} (¥{{ spec.comlist_f2 }}) 库存{{ spec.comlist_s1 }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="min-order-tip" v-if="currentGoodsDetail.mini_num && currentGoodsDetail.mini_num > 1">
          <i class="el-icon-info"></i> 本商品 {{ currentGoodsDetail.mini_num }} 件起订
        </div>
        <div class="quantity-section">
          <span>数量</span>
          <el-input-number
            v-model="purchaseQuantity"
            :min="currentGoodsDetail.mini_num || 1"
            :max="currentGoodsDetail.mx_list[currentSpecIndex]?.comlist_s1 || 999"
            size="medium"
            @change="onQuantityChange"
          />
        </div>
        <div class="purchase-buttons">
          <el-button type="primary" @click="addToCartFromPurchase">加入购物车</el-button>
          <el-button type="danger" @click="buyNow">立即购买</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- ========== 小程序二维码 Dialog ========== -->
        <el-dialog
          :visible.sync="showQRCodeDialog"
          width="420px"
          top="20vh"
          @close="closeQRCodeDialog"
          :close-on-click-modal="true"
          class="qrcode-dialog"
        >
          <div class="qrcode-dialog-body" v-loading="qrcodeLoading" element-loading-text="生成二维码中...">
            <div class="qrcode-header">
              <i class="el-icon-mobile-phone"></i>
              <span>扫码前往小程序选购</span>
            </div>
            <div class="qrcode-image-wrapper">
              <img
                v-if="qrcodeBase64"
                :src="qrcodeBase64"
                alt="小程序二维码"
                class="qrcode-image"
                @click="refreshQRCode"
              />
              <div v-else-if="!qrcodeLoading" class="qrcode-placeholder">
                <i class="el-icon-picture-outline"></i>
                <span>二维码加载失败</span>
                <el-button type="text" size="mini" @click="generateQRCode">点击重试</el-button>
              </div>
            </div>
            <div class="qrcode-tip">
              <span>微信扫一扫，直达商品页</span>
            </div>
            <div class="qrcode-extra">
              <span>商品ID：{{ currentGoodsDetail.id }}</span>
            </div>
          </div>
        </el-dialog>
  </div>
</template>

<script>
import xcxrequest from '@/utils/xcxrequest.js'
import request from '@/utils/request.js'
import Cookies from 'js-cookie'

// 防抖函数
function debounce (fn, delay = 300) {
  let timer = null
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export default {
  data () {
    return {
      // 原有数据
      categoryList: [],
      activeCategory: 'all',
      goodsList: [],
      searchKeyword: '',
      loading: false,
      bannerList: [],
      noticeText: '',
      newselectedCount: 0,
      showGoodsDetailLayer: false,
      showPurchaseLayer: false,
      currentGoodsDetail: {},
      currentSpecIndex: 0,
      purchaseQuantity: 1,
      provinceList: [],
      provinceId: '',
      requestId: 0,
      crmImg: '',
      showQRCodeDialog: false, // 控制二维码弹窗显示

      // ===== 轮播卡片数据 =====
      cardGroups: [
        { id: 66, name: '食品饮料' },
        { id: 69, name: '水产海鲜' },
        { id: 551, name: '禽畜肉类' },
        { id: 652, name: '米面粮油' }
      ],
      currentCardIndex: 0,
      cardGoodsMap: {},
      cardLoading: false,
      cardTimer: null,

      // ===== 2个大卡片数据（动态轮播） =====
      promoCards: [],

      // ===== 左侧分类树 =====574(6,3)2
      categoryTree: [
        {
          id: '5',
          name: '粮油调味',
          icon: 'el-icon-food',
          children: ['米面杂粮', '食用油', '调味品', '其他']
        },
        {
          id: '4',
          name: '肉奶蛋类',
          icon: 'el-icon-meat',
          children: ['猪肉类', '牛肉类', '羊肉类', '奶制品', '蛋类', '其他']
        },
        {
          id: '7',
          name: '食品饮料',
          icon: 'el-icon-drink',
          children: ['休闲食品', '速冻食品', '乳品饮料', '其他']
        },
        {
          id: '6',
          name: '蔬菜水果',
          icon: 'el-icon-vegetable',
          children: ['蔬菜', '水果', '其他']
        },
        {
          id: '2',
          name: '海鲜水产',
          icon: 'el-icon-seafood',
          children: ['鱼类', '虾类', '蟹类', '贝类', '其他水产']
        }
      ],

      // ===== 右侧用户信息 =====
      userInfo: {
        avatar: '/static/default_avatar.png',
        nickname: '吃货达人',
        orderCount: 12,
        points: 3680
      },

      qrcodeBase64: '', // 二维码图片 base64
      qrcodeLoading: false, // 加载状态
      qrcodeApiUrl: '/index/getxxqr_code.php' // 二维码生成接口地址（按需修改）
    }
  },
  computed: {
    activeCategoryName () {
      const cat = this.categoryList.find(c => c.id === this.activeCategory)
      return cat ? (cat.comlist_v1 || cat.bfenlei4) : '全部'
    },
    currentPurchasePrice () {
      if (this.currentGoodsDetail.mx_list && this.currentGoodsDetail.mx_list[this.currentSpecIndex]) {
        return this.currentGoodsDetail.mx_list[this.currentSpecIndex].comlist_f2
      }
      return this.currentGoodsDetail.currentPrice
    },
    currentCardGroup () {
      return this.cardGroups[this.currentCardIndex] || this.cardGroups[0]
    },
    currentCardGoods () {
      const key = this.currentCardGroup.id
      return this.cardGoodsMap[key] || []
    },
    pageContentList () {
      return this.parsePageMain(this.currentGoodsDetail.page_main || '')
    }
  },
  created () {
    this.loadUserInfo()
    this.initData()
    this.fetchAllCardGoods()
    this.startCardTimer()
    this.crmImg = localStorage.getItem('crm_img')
    console.log(this.crmImg, 11111)
  },
  beforeDestroy () {
    this.stopCardTimer()
  },
  mounted () {
    this.getCartCount()
  },
  methods: {
    openQRCodeDialog () {
      this.showQRCodeDialog = true
      if (!this.qrcodeBase64 || this.currentGoodsDetail.id !== this._lastQRGoodsId) {
        this.generateQRCode()
      }
      this._lastQRGoodsId = this.currentGoodsDetail.id // 记录商品ID，避免重复生成
    },
    closeQRCodeDialog () {
      this.showQRCodeDialog = false
    },
    toLogin () {
      Cookies.remove('token')
      localStorage.clear()
      this.$router.push('/login')
    },
    loadUserInfo () {
      const crmId = localStorage.getItem('crm_id')
      if (crmId) {
        this.userInfo.nickname = localStorage.getItem('user_name') || '用户'
        this.userInfo.avatar = localStorage.getItem('user_avatar')
      }
    },
    getUserId () {
      return localStorage.getItem('crm_id') || ''
    },
    async initData () {
      await this.getProvinceList()
      await this.newlist()
      await this.getBannerList()
      await this.getpao()
      await this.newgetGoodsList()
    },
    async newlist () {
      const result = await xcxrequest.post('/goods/goods_list.php?a=getLeimu')
      if (result.code === '0') {
        this.categoryList = [
          { id: 'all', comlist_v1: '推荐' },
          ...result.data
        ]
      }
    },
    async getBannerList () {
      try {
        const res = await request.post('/index/new_lunbo_list.php')
        const res1 = await request.post('/index/new_lunbo_list.php', { bfenlei: 53 })
        const res2 = await request.post('/index/new_lunbo_list.php', { bfenlei: 54 })
        console.log(res1)
        console.log(res2)
        if (res.code === 0 && res.res) {
          this.bannerList = res.res.map(item => ({ ...item, link: '/pages/com/com_jiben_add' }))
        }

        const cardConfigs = [
          {
            bfenlei: 54,
            tag: '新品首发',
            title: '潮流新品 抢先体验',
            desc: '每周三上新 专属优惠等你来',
            btnText: '探索新品',
            link: '/newarrivals'
          },
          {
            bfenlei: 53,
            tag: '限时秒杀',
            title: '精选好物 限时抢购',
            desc: '每天10点/14点/20点 准时开抢',
            btnText: '立即抢购',
            link: '/seckill'
          }
        ]

        const results = [res1, res2]
        this.promoCards = cardConfigs.map((cfg, idx) => {
          const data = results[idx]
          let images = []
          if (data && data.code === 0 && data.res && data.res.length) {
            images = data.res.map(item => ({ img: item.img, title: item.title, link: item.link }))
          } else {
            images = [{ img: '/static/promo-bg-1.jpg' }]
          }
          return { ...cfg, images }
        })
      } catch (err) {
        console.error('轮播图获取失败', err)
      }
    },
    async getpao () {
      try {
        const res = await xcxrequest.post('/controller/homePage.php?a=notice')
        if (res.code === 0 && res.res && res.res.length) {
          this.noticeText = res.res.join('  ')
        }
      } catch (err) {
        console.error('公告获取失败', err)
      }
    },
    async getProvinceList () {
      try {
        const res = await xcxrequest.post('/gouwu/address.php?a=provinces')
        if (res.code === 0 && Array.isArray(res.data)) {
          this.provinceList = [{ id: '0', name: '全部' }, ...res.data]
          const cached = localStorage.getItem('selectedProvinceId')
          this.provinceId = cached || '0'
        }
      } catch (err) {
        console.error('省份获取失败', err)
      }
    },
    onProvinceChange (val) {
      localStorage.setItem('selectedProvinceId', val)
      this.newgetGoodsList()
    },
    selectCategory (cat) {
      if (this.activeCategory === cat.id) return
      console.log(cat.id)
      this.activeCategory = cat.id
      this.searchKeyword = ''
      this.newgetGoodsList()
    },
    goToSearchPage (catId) {
      const keyword = this.searchKeyword.trim()
      const query = { category: catId || this.activeCategory }
      if (keyword) query.keyword = keyword
      this.$router.push({ path: '/Changeshop', query })
    },
    async newgetGoodsList () {
      const currentRequestId = ++this.requestId
      this.loading = true
      const params = {
        leimu_id: this.activeCategory === 'all' ? '0' : this.activeCategory,
        userId: this.getUserId()
      }
      if (this.searchKeyword && this.searchKeyword.trim()) {
        params.comlist_v1 = this.searchKeyword.trim()
      }
      if (this.provinceId && this.provinceId !== '0') {
        params.province_id = this.provinceId
      }
      try {
        const res = await xcxrequest.post('/goods/goods_list.php?a=lists', params)
        if (currentRequestId !== this.requestId) return
        this.goodsList = (res.data && res.data.data) ? res.data.data : []
      } catch (err) {
        console.error('获取商品列表失败', err)
        if (currentRequestId === this.requestId) this.goodsList = []
      } finally {
        if (currentRequestId === this.requestId) this.loading = false
      }
    },
    onSearchInput: debounce(function () {
      this.newgetGoodsList()
    }, 300),
    goToCart () {
      //   this.$router.push('/cart')
    },
    getCartCount () {
      xcxrequest.post('/gouwu/shopCart.php?a=selCount', { user_id: this.getUserId() })
        .then(res => {
          if (res.code === 0) this.newselectedCount = res.data.number
        }).catch(err => console.error('购物车数量获取失败', err))
    },
    showGoodsDetailpage (good) {
      const goodsData = good.goods_data
      const mxData = good.mx_data || []
      const mxList = mxData.map(spec => ({
        id: spec.id,
        comlist_v1: spec.comlist_v1,
        comlist_f2: spec.comlist_f2,
        comlist_s1: spec.comlist_s1
      }))
      const totalStock = mxList.reduce((sum, s) => sum + (parseInt(s.comlist_s1) || 0), 0)
      this.currentGoodsDetail = {
        id: goodsData.id,
        goods_id: goodsData.id,
        name: goodsData.comlist_v1,
        image: goodsData.comlist_v8,
        currentPrice: mxList[0]?.comlist_f2 || 0,
        comlist_s1: totalStock,
        mx_list: mxList,
        comlist_m1: goodsData.comlist_m1,
        sh_img: goodsData.sh_img,
        sh_name: goodsData.sh_name,
        sh_id: goodsData.sh_id,
        page_main: goodsData.page_main || '',
        mini_num: goodsData.mini_num || 1,
        labels: goodsData.labels || []
      }
      this.showGoodsDetailLayer = true

      // ===== ★★★ 新增：弹窗打开后生成二维码 ★★★ =====
      this.generateQRCode()
    },
    hideGoodsDetail () {
      this.showGoodsDetailLayer = false
      // 关闭弹窗时清空二维码，避免下次打开时显示旧数据
      this.qrcodeBase64 = ''
      this.qrcodeLoading = false
    },
    openPurchaseLayer () {
      this.currentSpecIndex = 0
      this.purchaseQuantity = this.currentGoodsDetail.mini_num || 1
      this.initPurchaseQuantityBySpec()
      this.showPurchaseLayer = true
    },
    hidePurchaseLayer () {
      this.showPurchaseLayer = false
    },
    initPurchaseQuantityBySpec () {
      const spec = this.currentGoodsDetail.mx_list[this.currentSpecIndex]
      if (!spec) return
      const stock = parseInt(spec.comlist_s1) || 0
      const minNum = parseInt(this.currentGoodsDetail.mini_num) || 1
      let qty = minNum
      if (stock > 0 && qty > stock) qty = stock
      this.purchaseQuantity = qty > 0 ? qty : 1
    },
    onQuantityChange (val) {
      // 可做额外校验
    },
    async addToCartFromPurchase () {
      const selectedSpec = this.currentGoodsDetail.mx_list[this.currentSpecIndex]
      const params = {
        user_id: this.getUserId(),
        ids: [{
          goods_id: this.currentGoodsDetail.goods_id,
          mx_id: selectedSpec.id,
          add_num: this.purchaseQuantity,
          sh_id: this.currentGoodsDetail.sh_id
        }]
      }
      try {
        const res = await xcxrequest.post('/gouwu/shopCart.php?a=add', params)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.getCartCount()
          this.hidePurchaseLayer()
        } else {
          this.$message.error(res.msg || '添加失败')
        }
      } catch (err) {
        console.error('加入购物车失败', err)
      }
    },
    buyNow () {
      const minNum = parseInt(this.currentGoodsDetail.mini_num) || 1
      if (this.purchaseQuantity < minNum) {
        this.$message.warning(`最少购买${minNum}件`)
        return
      }
      const selectedSpec = this.currentGoodsDetail.mx_list[this.currentSpecIndex]
      const item = {
        ...this.currentGoodsDetail,
        quantity: this.purchaseQuantity,
        selectedSpecId: selectedSpec.id,
        selectedSpec: selectedSpec,
        currentPrice: selectedSpec.comlist_f2
      }
      const erpMainStr = encodeURIComponent(JSON.stringify({ sh_name: '店铺', sh_img: '' }))
      this.$router.push({
        path: '/order/confirm',
        query: {
          total: (item.currentPrice * item.quantity).toFixed(2),
          erp_main: erpMainStr,
          sh_id: this.currentGoodsDetail.sh_id
        },
        params: { selectedGoods: [item] }
      })
      this.hidePurchaseLayer()
    },
    goToShop (shId) {
      this.$router.push(`/shop/${shId}`)
    },
    getFilteredMediaList (mediaList) {
      if (!mediaList || !Array.isArray(mediaList)) return []
      return mediaList.filter(item => item)
    },
    isImage (url) {
      if (!url) return false
      return /\.(jpg|jpeg|png|gif|bmp|webp|svg)/i.test(url)
    },
    isVideo (url) {
      if (!url) return false
      return /\.(mp4|avi|mov|wmv|flv|webm|m3u8)/i.test(url)
    },
    onBannerClick (banner) {
      //   if (banner.link) {
      //     if (banner.link.startsWith('/')) {
      //       this.$router.push(banner.link)
      //     } else {
      //       window.open(banner.link)
      //     }
      //   }
    },
    handleParseError (err) {
      console.error('动态内容解析错误', err)
    },
    onPromoClick (card) {
      const categoryMap = {
        新品首发: 'newarrival',
        限时秒杀: 'seckill'
      }
      const category = categoryMap[card.tag]
      console.log(category)
      if (category) {
        this.$router.push({ path: '/Changeshop', query: { category } })
      } else {
        this.$message.info(`即将进入「${card.title}」专区`)
      }
    },
    async fetchAllCardGoods () {
      this.cardLoading = true
      try {
        const promises = this.cardGroups.map(group =>
          request.post('/admin/caixgoods_lists.php', {
            a: 'goodsLista',
            group_id: group.id,
            user_type: 'caigou'
          })
        )
        const results = await Promise.all(promises)

        results.forEach((res, index) => {
          const group = this.cardGroups[index]
          if (res.code === '0' && res.data && res.data.length) {
            const list = res.data.map(item => {
              const specs = item.specs || item.mx_data || []
              const firstSpec = specs[0] || {}
              return {
                id: item.id,
                name: item.name || item.comlist_v1 || '商品',
                price: firstSpec.comlist_f2 || item.price || '0.00',
                image: item.image || item.comlist_v8 || '/static/default_goods.png',
                raw: item
              }
            })
            this.$set(this.cardGoodsMap, group.id, list)
          } else {
            this.$set(this.cardGoodsMap, group.id, [])
          }
        })
      } catch (err) {
        console.error('获取商品卡片数据失败', err)
        this.cardGroups.forEach(g => {
          if (!this.cardGoodsMap[g.id]) {
            this.$set(this.cardGoodsMap, g.id, [])
          }
        })
      } finally {
        this.cardLoading = false
      }
    },
    startCardTimer () {
      if (this.cardTimer) clearInterval(this.cardTimer)
      this.cardTimer = setInterval(() => {
        const next = (this.currentCardIndex + 1) % this.cardGroups.length
        this.currentCardIndex = next
      }, 3000)
    },
    stopCardTimer () {
      if (this.cardTimer) {
        clearInterval(this.cardTimer)
        this.cardTimer = null
      }
    },
    switchCardCategory (index) {
      if (index === this.currentCardIndex) return
      this.currentCardIndex = index
      this.stopCardTimer()
      this.startCardTimer()
    },
    onGoodsCardClick (item) {
      if (item.raw) {
        const raw = item.raw
        const mxData = raw.specs || raw.mx_data || []
        const mxList = mxData.map(spec => ({
          id: spec.id,
          comlist_v1: spec.comlist_v1 || '标准',
          comlist_f2: spec.comlist_f2 || 0,
          comlist_s1: spec.comlist_s1 || 0
        }))
        const totalStock = mxList.reduce((sum, s) => sum + (parseInt(s.comlist_s1) || 0), 0)
        const detail = {
          id: raw.id,
          goods_id: raw.id,
          name: raw.name || raw.comlist_v1 || '商品',
          image: raw.image || raw.comlist_v8 || '/static/default_goods.png',
          currentPrice: mxList[0]?.comlist_f2 || 0,
          comlist_s1: totalStock,
          mx_list: mxList,
          comlist_m1: raw.comlist_m1 || [],
          sh_img: raw.sh_img || '',
          sh_name: raw.sh_name || '',
          sh_id: raw.sh_id || '',
          page_main: raw.page_main || '',
          mini_num: raw.mini_num || 1,
          labels: raw.labels || []
        }
        this.currentGoodsDetail = detail
        this.showGoodsDetailLayer = true
        // ★★★ 生成二维码 ★★★
        this.generateQRCode()
      } else {
        this.$message.info(`您选择了：${item.name}`)
      }
    },
    onCategoryClick (cat) {
      this.selectCategory(cat)
      // this.$message.info(`查看「${cat.name}」分类`)
    },
    onSubCategoryClick (cat, sub) {
      this.selectCategory(cat)
      // this.$message.info(`查看「${cat.name}」下的「${sub}」商品`)
    },
    goToOrders () {
      this.$router.push('/ePower/connection')
    },
    goToContracts () {
      this.$router.push('/hetong/hetongcgList')
    },
    goToProfile () {
      this.$router.push('/eLife/caiadmin')
    },
    parsePageMain (pageMain) {
      if (!pageMain) return []
      try {
        let jsonStr = pageMain.replace(/&quot;/g, '"')
        jsonStr = jsonStr
          .replace(/\\n/g, '\\n')
          .replace(/\\r/g, '\\r')
          .replace(/\\t/g, '\\t')

        const dataArray = JSON.parse(jsonStr)

        return dataArray.map(item => {
          if (item.type === 'text' && typeof item.content === 'string') {
            item.content = item.content
              .replace(/\\n/g, '\n')
              .replace(/\\r/g, '\r')
          }
          return item
        })
      } catch (error) {
        console.error('解析 page_main 失败:', error, pageMain)
        this.$message.error('商品详情数据格式异常')
        return []
      }
    },
    copyText (text) {
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$message.success('复制成功')
          })
          .catch(() => {
            this.fallbackCopyText(text)
          })
      } else {
        this.fallbackCopyText(text)
      }
    },
    fallbackCopyText (text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    },
    async saveImage (imageUrl) {
      if (!imageUrl) return
      try {
        const filename = imageUrl.split('/').pop() || 'image.jpg'
        const response = await fetch(imageUrl, { mode: 'cors' })
        if (!response.ok) throw new Error('图片下载失败')
        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => URL.revokeObjectURL(link.href), 1000)
        this.$message.success('图片保存成功')
      } catch (error) {
        console.error('保存图片失败:', error)
        if (error.message.includes('fetch') || error.message.includes('cors')) {
          window.open(imageUrl, '_blank')
          this.$message.info('已在新窗口打开图片，请右键保存')
        } else {
          this.$message.error('保存图片失败，请重试')
        }
      }
    },
    async saveVideo (videoUrl) {
      if (!videoUrl) return
      try {
        const filename = videoUrl.split('/').pop() || 'video.mp4'
        const response = await fetch(videoUrl, { mode: 'cors' })
        if (!response.ok) throw new Error('视频下载失败')
        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => URL.revokeObjectURL(link.href), 1000)
        this.$message.success('视频保存成功')
      } catch (error) {
        console.error('保存视频失败:', error)
        if (error.message.includes('fetch') || error.message.includes('cors')) {
          window.open(videoUrl, '_blank')
          this.$message.info('已在新窗口打开视频，请右键保存')
        } else {
          this.$message.error('保存视频失败，请重试')
        }
      }
    },

    // ================================================================
    // ★★★ 新增：小程序二维码生成方法 ★★★
    // ================================================================
    async generateQRCode () {
      const goodsId = this.currentGoodsDetail.id
      if (!goodsId) {
        console.warn('商品ID不存在，无法生成二维码')
        return
      }

      // 如果已有二维码且商品ID相同，不重复生成（可节省接口调用）
      // 但每次打开弹窗都重新生成，确保参数最新
      this.qrcodeBase64 = ''
      this.qrcodeLoading = true

      try {
        // 调用后端 PHP 接口生成小程序码
        const res = await request.post(this.qrcodeApiUrl, {
          page: 'pages/member/new_jiben_list', // 小程序商品详情页路径（按实际调整）
          scene: `goods_id=${goodsId}`, // 携带商品ID，最多32字符
          width: 280, // 二维码尺寸
          env_version: 'release' // release / trial / develop
        })

        if (res.code === 0 && res.qrcode_base64) {
          this.qrcodeBase64 = res.qrcode_base64
        } else {
          this.$message.error(res.msg || '生成二维码失败，请稍后重试')
          console.error('二维码生成失败:', res)
        }
      } catch (err) {
        console.error('调用二维码接口异常:', err)
        this.$message.error('网络异常，生成二维码失败')
      } finally {
        this.qrcodeLoading = false
      }
    },

    // 刷新二维码（点击二维码图片触发）
    refreshQRCode () {
      if (this.qrcodeLoading) return
      this.$message.info('正在刷新二维码...')
      this.generateQRCode()
    }
  }
}
</script>

<style lang="scss" scoped>
// ============================================================
// 全局重置 & 容器
// ============================================================
.pc-container {
  height: 90vh;
  overflow-y: auto;
  min-width: 780px;
  padding: 10vh 4vw 0;
  background: #f5f5f5;
  font-family: "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
  border: 1px solid;

}
.pc-container::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}
.pc-container::-webkit-scrollbar-thumb {
  background: transparent; /* 默认透明隐藏 */
  border-radius: 4px;
}

// ============================================================
// 顶部导航栏
// ============================================================
.header {
  width:100%;
  min-width: 780px;
  position: fixed;
  top: 0;
  left: 0;
  background: #f5f5f5;
  border-bottom: 1px solid #c4c4c4;
  z-index: 1000;
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 40px;

    .right-menu {
      vertical-align: super;
      .el-button {
        color: #000;
        font-size: 15px;
        font-weight: 500;
        margin-left: 20px;
        &:hover {
          color: #313b33;
        }
      }
    }
  }
}

// ============================================================
// 搜索条
// ============================================================
.page-search-bar {
  margin: 0 auto 10px;
  border-radius: 8px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  min-width: 780px;

  .logo {
    flex-shrink: 0;
  }

  .search-area {
    flex: 1 1 58vw;
    max-width: 1000px;
    margin-left: 2vw;
    display: flex;
    min-width: 280px;
    border: 2px solid green;
    border-radius: 10px;

    .search-input {
      flex: 1;
      border-radius: 10px;
      border: 4px solid green;
      .el-input__inner {
        border-radius: 0;
        border-left: none;
        height: 40px;
        background: #fff;
        border-color: #dcdfe6;
      }
      .el-input-group__append {
        background: #01582B;
        border: none;
        border-radius: 0 20px 20px 0;
        padding: 0 16px;
        .el-button {
          color: #fff;
          background: transparent;
          border: none;
          font-size: 16px;
          &:hover {
            background: rgba(255, 255, 255, 0.15);
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    .search-area {
      flex: 1 1 auto;
      max-width: 100%;
      margin: 0;
      flex-wrap: wrap;
      .search-input {
        .el-input__inner {
          border-radius: 20px 0 0 20px;
        }
      }
    }
  }
}

// ============================================================
// 公告栏
// ============================================================
.notice-bar {
  margin: 10px auto 0;
  background: #eaf7ed;
  border-radius: 4px;
  padding: 6px 20px;
  display: flex;
  align-items: center;
  border: 1px solid #b8d9c1;
  .el-icon-megaphone {
    color: #01582B;
    font-size: 20px;
    margin-right: 12px;
  }
  .notice-carousel {
    flex: 1;
    .notice-text {
      color: #004d23;
      font-weight: 500;
    }
  }
}

// ============================================================
// 3个小卡片（左侧分类 + 中间轮播 + 右侧我的卡片）
// ============================================================
.stats-cards-wrapper {
  margin: 10px auto 0;
  min-width: 780px;
  .stat-card {
    display: flex;
    height: 24vh;
     min-height: 200px;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    padding: 13px 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    cursor: default;
    border-left: 4px solid #01582B;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 28px rgba(0, 104, 48, 0.12);
    }

    &.stat-card-0 { border-left-color: #01582B; max-height: 250px; }
    &.stat-card-3 { border-left-color: #e74c6f; }
  }

  .category-card {
    padding: 12px 16px !important;
    flex-direction: column;
    align-items: stretch;
    height: 24vh;
    overflow-y: auto;
    .category-tree {
      width: 100%;
      .category-branch {
        margin-bottom: 8px;
        .category-level1 {
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: bold;
          font-size: 14px;
          color: #01582B;
          cursor: pointer;
          padding: 2px 0;
          i {
            font-size: 18px;
          }
          &:hover {
            color: #004d1f;
          }
        }
        .category-level2 {
          display: flex;
          flex-wrap: wrap;
          gap: 4px 8px;
          margin-top: 2px;
          padding-left: 24px;
          .sub-tag {
            font-size: 12px;
            color: #555;
            background: #f0f8f2;
            padding: 0 10px;
            border-radius: 12px;
            line-height: 24px;
            cursor: pointer;
            transition: all 0.2s;
            &:hover {
              background: #01582B;
              color: #fff;
            }
          }
        }
      }
    }
  }

  .stat-card-goods {
    padding: 12px 16px !important;
    flex-direction: column;
    align-items: stretch;
    border-left-color: #2d8cf0;
    height: 24vh;
    min-height: 200px;

    .goods-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      padding-bottom: 6px;
      border-bottom: 1px solid #e8f0ea;
      flex-shrink: 0;

      .goods-category-title {
        font-weight: bold;
        color: #01582B;
        font-size: 16px;
        white-space: nowrap;
      }
      .goods-more {
        font-size: 13px;
        color: #888;
        cursor: pointer;
        white-space: nowrap;
        &:hover {
          color: #01582B;
        }
      }
      .card-dots {
        display: flex;
        gap: 5px;
        margin-left: 8px;
        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #d0d8d0;
          transition: all 0.3s;
          cursor: pointer;
          &.active {
            background: #01582B;
            transform: scale(1.3);
          }
          &:hover {
            background: #01582B;
          }
        }
      }
    }

    .goods-list {
      flex: 1;
      display: flex;
      gap: 12px;
      // justify-content: space-evenly;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 8px 4px 12px;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #c8e0cf;
        border-radius: 2px;
      }
      &::-webkit-scrollbar-track {
        background: #f0f5f0;
      }

      animation: cardFadeIn 0.4s ease;

      .goods-item {
        flex: 0 0 110px;
        cursor: pointer;
        text-align: center;
        transition: transform 0.25s ease, box-shadow 0.25s ease;
        border-radius: 8px;
        padding: 6px 4px;
        margin: 0  10px ;
        background: #fafcfa;
        &:hover {
          transform: translateY(-6px) scale(1.02);
          box-shadow: 0 6px 20px rgba(0, 104, 48, 0.12);
          background: #fff;
        }
        img {
          width: 100%;
          aspect-ratio: 1/1;
          max-width: 110px;
          height: auto;
          object-fit: cover;
          border-radius: 8px;
          border: 2px solid #ff2e2e;
          background: #f9fbf9;
          transition: border-color 0.2s;
        }
        &:hover img {
          border-color: #01582B;
        }
        .goods-name {
          font-size: 13px;
          margin-top: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 110px;
          color: #333;
          font-weight: 500;
        }
        .goods-price {
          color: #01582B;
          font-size: 16px;
          font-weight: bold;
          &::before {
            content: "¥";
            font-size: 12px;
            font-weight: normal;
          }
        }
      }

      .empty-tip {
        width: 100%;
        text-align: center;
        color: #999;
        font-size: 14px;
        line-height: 120px;
        align-self: center;
      }
    }
  }

  .stat-card-3.my-card {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-left-color: #7d2b0e;
    .my-links {
      display: flex;
      justify-content: space-around;
      width: 100%;
      margin-top: 12px;
      padding: 0 4px;
    }

    .link-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      color: #555;
      transition: color 0.2s, transform 0.2s;
      padding: 4px 8px;
      border-radius: 6px;

      i {
        font-size: 24px;
        color: #01582B;
        margin-bottom: 4px;
        transition: transform 0.2s;
      }

      span {
        font-size: 13px;
        font-weight: 500;
      }

      &:hover {
        color: #01582B;
        background: #f0f8f2;
        transform: translateY(-2px);

        i {
          transform: scale(1.1);
        }
      }

      &:active {
        transform: scale(0.96);
      }
    }

    .my-avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      border: 3px solid #01582B;
      margin-bottom: 8px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .my-name {
      font-size: 18px;
      font-weight: bold;
      color: #222;
      margin-bottom: 6px;
    }
    .my-extra {
      display: flex;
      gap: 16px;
      font-size: 13px;
      color: #666;
      span {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        i {
          color: #01582B;
        }
      }
    }
    .my-btn {
      margin-top: 10px;
      color: #01582B;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

@keyframes cardFadeIn {
  0% {
    opacity: 0.3;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

// ============================================================
// 2个大卡片（促销活动）
// ============================================================
.promo-cards-wrapper {
  margin: 16px auto 0;

  .promo-card {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    height: 180px;
    background: #e8f0ea;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.35s ease;
    cursor: pointer;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 36px rgba(0, 104, 48, 0.16);
      .promo-overlay {
        background: rgba(0, 50, 20, 0.55);
      }
    }

    .promo-carousel {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .el-carousel__item {
        .promo-bg-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .promo-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0, 50, 20, 0.40);
      padding: 28px 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: background 0.35s ease;
      z-index: 1;
      pointer-events: none;

      .promo-tag,
      .promo-title,
      .promo-desc,
      .promo-btn {
        pointer-events: auto;
      }

      .promo-tag {
        display: inline-block;
        background: #ff6b35;
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        padding: 2px 16px;
        border-radius: 20px;
        width: fit-content;
        margin-bottom: 10px;
        letter-spacing: 1px;
      }

      .promo-title {
        color: #fff;
        font-size: 24px;
        font-weight: bold;
        margin: 0 0 6px 0;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }

      .promo-desc {
        color: rgba(255, 255, 255, 0.85);
        font-size: 14px;
        margin: 0 0 16px 0;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
      }

      .promo-btn {
        background: #fff;
        border-color: #fff;
        color: #01582B;
        font-weight: 600;
        width: fit-content;
        border-radius: 20px;
        padding: 8px 28px;
        &:hover {
          background: #f0f8f2;
          border-color: #f0f8f2;
          color: #004d1f;
        }
      }
    }
  }
}

// ============================================================
// 类目商品tab
// ============================================================
.category-tab-wrapper {
  margin: 16px auto 0;
}

.category-nav {
  background: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  .category-scroll {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .category-item {
      padding: 6px 20px;
      border-radius: 20px;
      font-size: 14px;
      color: #555;
      cursor: pointer;
      background: #f0f0f0;
      transition: all 0.25s;
      &:hover {
        background: #dff0e2;
        color: #01582B;
      }
      &.active {
        background: #01582B;
        color: #fff;
        box-shadow: 0 2px 6px rgba(0, 104, 48, 0.3);
      }
    }
  }
}

.banner-wrapper {
  margin-bottom: 24px;
  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
  .el-carousel__arrow {
    background: rgba(0, 0, 0, 0.3);
    &:hover {
      background: rgba(0, 104, 48, 0.7);
    }
  }
}

.goods-section {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    padding: 16px 0;
    border-bottom: 2px solid #01582B;
    margin-bottom: 20px;
    color: #222;
    .sub-title {
      font-size: 14px;
      font-weight: normal;
      color: #999;
      margin-left: 12px;
    }
  }
  .goods-card {
    cursor: pointer;
    transition: transform 0.25s, box-shadow 0.25s;
    border-radius: 8px;
    overflow: hidden;
    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 8px 24px rgba(0, 104, 48, 0.12);
    }
    .goods-img-wrapper {
      position: relative;
      height: 200px;
      overflow: hidden;
      background: #f7f7f7;
      .goods-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s;
      }
      &:hover .goods-img {
        transform: scale(1.03);
      }
      .new-tag {
        position: absolute;
        top: 8px;
        right: 8px;
        background: #01582B;
        color: #fff;
        padding: 2px 14px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: bold;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
      }
    }
    .goods-info {
      padding: 10px 12px 12px;
      .goods-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #333;
      }
      .goods-tags {
        margin: 6px 0;
        .tag {
          display: inline-block;
          background: #eaf7ed;
          color: #01582B;
          font-size: 12px;
          padding: 0 10px;
          border-radius: 10px;
          margin-right: 4px;
          line-height: 22px;
        }
      }
      .goods-price {
        color: #01582B;
        font-size: 20px;
        font-weight: bold;
        &::before {
          content: "¥";
          font-size: 14px;
        }
      }
    }
  }
  .empty-tip {
    text-align: center;
    padding: 60px 0;
    color: #999;
    font-size: 16px;
  }
}

// ============================================================
// ★★★ 商品详情弹窗 - 左侧滚动 + 右侧固定 ★★★
// ============================================================
.goods-detail-dialog {
  .el-dialog {
    border-radius: 12px;
    overflow: hidden;
  }

  .detail-body {
    height: 100%;

    .detail-layout {
      display: flex;
      gap: 24px;
      height: 70vh;
      max-height: 70vh;
      align-items: flex-start;

      .detail-left {
        height:100%;
        width:60%;
        overflow-y: auto;
        padding-right: 8px;

        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: #c8e0cf;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-track {
          background: #f0f5f0;
        }

        .detail-img {
          width: 100%;
          object-fit: contain;
          background: #f9f9f9;
        }

        .detail-content {
          margin-top: 24px;

          .goods-detail-section {
            border-top: 1px solid #e0eee3;
            padding-top: 16px;

            h3 {
              font-size: 18px;
              color: #222;
              margin-bottom: 16px;
              font-weight: 600;
            }

            .dynamic-content-wrapper {
              display: flex;
              flex-direction: column;
              gap: 16px;

              .content-item {
                width: 100%;
              }

              .text-item {
                background: #f8faf8;
                border-radius: 8px;
                padding: 16px 20px;
                border: 1px solid #e8f0ea;
                cursor: pointer;
                transition: all 0.25s ease;
                position: relative;

                &:hover {
                  border-color: #01582B;
                  box-shadow: 0 2px 12px rgba(0, 104, 48, 0.08);
                  .copy-hint {
                    opacity: 1;
                  }
                }

                .text-content {
                  font-size: 14px;
                  color: #333;
                  line-height: 1.8;
                  white-space: pre-line;
                  word-break: break-word;
                }

                .copy-hint {
                  position: absolute;
                  right: 16px;
                  top: 50%;
                  transform: translateY(-50%);
                  opacity: 0;
                  transition: opacity 0.3s ease;
                  color: #01582B;
                  font-size: 12px;

                  i {
                    margin-right: 4px;
                  }
                }
              }

              .image-item {
                position: relative;
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;
                background: #f7f7f7;
                border: 1px solid #e8f0ea;
                transition: all 0.3s ease;

                &:hover {
                  border-color: #01582B;
                  box-shadow: 0 4px 16px rgba(0, 104, 48, 0.12);
                  .image-hint {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }

                img {
                  width: 100%;
                  height: auto;
                  display: block;
                }

                .image-hint {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  background: rgba(0, 50, 20, 0.7);
                  color: #fff;
                  text-align: center;
                  padding: 8px 0;
                  font-size: 13px;
                  opacity: 0;
                  transform: translateY(100%);
                  transition: all 0.3s ease;
                  backdrop-filter: blur(4px);

                  i {
                    margin-right: 6px;
                  }
                }

                &.big-image {
                  width: 100%;
                  img {
                    object-fit: contain;
                  }
                }

                &.small-image {
                  display: inline-block;
                  width: 30%;
                  margin-right: 1.5%;
                  margin-bottom: 12px;
                  max-height: 260px;

                  img {
                    max-height: 260px;
                    object-fit: cover;
                  }

                  &:nth-child(3n) {
                    margin-right: 0;
                  }

                  .image-hint {
                    padding: 4px 0;
                    font-size: 12px;
                  }
                }
              }

              .video-item {
                border-radius: 8px;
                overflow: hidden;
                background: #0a0a0a;
                border: 1px solid #e8f0ea;

                .content-video {
                  width: 100%;
                  max-height: 480px;
                  display: block;
                }

                .video-actions {
                  padding: 12px 16px;
                  background: #f8faf8;
                  border-top: 1px solid #e8f0ea;
                  display: flex;
                  justify-content: flex-end;

                  .el-button {
                    background: #01582B;
                    border-color: #01582B;
                    color: #fff;

                    &:hover {
                      background: #005225;
                      border-color: #005225;
                    }
                  }
                }
              }

              .tag-item {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
                padding: 4px 0;

                .tag {
                  display: inline-block;
                  padding: 6px 18px;
                  border-radius: 20px;
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 1.5;
                  transition: all 0.2s ease;

                  &.tag-primary {
                    background: #01582B;
                    color: #fff;
                  }
                  &.tag-success {
                    background: #52c41a;
                    color: #fff;
                  }
                  &.tag-warning {
                    background: #faad14;
                    color: #fff;
                  }
                }
              }

              .unknown-item {
                padding: 8px 0;
              }
            }
          }

          .price-note-section {
            background: #f4faf6;
            padding: 16px 20px;
            border-radius: 6px;
            margin-top: 20px;

            h4 {
              color: #01582B;
              margin: 0 0 8px 0;
              font-weight: 600;
            }

            ul {
              padding-left: 20px;
              margin: 0;
              li {
                line-height: 1.8;
                color: #555;
                font-size: 14px;
              }
            }
          }
        }
      }

      .detail-right {
        flex: 0 0 38%;
        position: sticky;
        top: 0;
        align-self: flex-start;
        background: #fff;
        border-left: 1px solid #e8f0ea;
        padding-left: 20px;
        max-height: 70vh;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: #c8e0cf;
          border-radius: 4px;
        }

        .detail-info {
          h2 {
            margin-top: 0;
            font-size: 22px;
            color: #222;
          }
          .detail-price {
            font-size: 28px;
            color: #01582B;
            margin: 12px 0;
            font-weight: bold;
            &::before {
              content: "¥";
              font-size: 20px;
            }
          }
          .detail-stock {
            color: #888;
            font-size: 14px;
            margin-bottom: 12px;
          }
          .detail-specs {
            margin: 12px 0 16px 0;
            .spec-label {
              font-weight: 500;
              color: #333;
              margin-bottom: 6px;
            }
            .spec-items {
              display: flex;
              flex-wrap: wrap;
              gap: 8px;
              .spec-tag {
                height: 48px;
                font-size: 14px;
                padding: 10px 14px;
                background: #f5f8f5;
                border-color: #b8d9c1;
                color: #01582B;
                .spec-stock {
                  font-size: 12px;
                  color: #888;
                  margin-left: 4px;
                }
                &.el-tag--success {
                  background: #eaf7ed;
                  border-color: #01582B;
                  color: #01582B;
                }
                &.el-tag--info {
                  background: #f0f0f0;
                  border-color: #d0d8d0;
                  color: #999;
                }
              }
            }
          }
          .shop-info {
            display: flex;
            align-items: center;
            margin: 16px 0;
            padding: 10px 12px;
            background: #f0f8f2;
            border-radius: 6px;
            .shop-logo {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 10px;
              border: 1px solid #c8e0cf;
            }
            .shop-name {
              flex: 1;
              font-weight: 500;
              color: #333;
            }
            .el-button {
              background: #01582B;
              border-color: #01582B;
              color: #fff;
              &:hover {
                background: #005225;
                border-color: #005225;
              }
            }
          }
          .purchase-tip {
              margin: 12px 0 16px 0;
              .tip-text {
                color: #999;
                font-size: 13px;
                line-height: 1.5;
                display: block;
                border-top: 1px dashed #e0eee3;
                padding-top: 12px;
              }
            }

          // ===== ★★★ 新增：二维码模块样式 ★★★ =====
          .qrcode-module {
            margin: 16px 0 12px 0;
            padding: 12px 16px;
            background: #f8faf8;
            border-radius: 10px;
            border: 1px solid #e0eee3;
            transition: all 0.3s ease;

            &:hover {
              border-color: #01582B;
              box-shadow: 0 2px 12px rgba(0, 104, 48, 0.08);
            }

            .qrcode-header {
              display: flex;
              align-items: center;
              gap: 6px;
              font-weight: 600;
              font-size: 15px;
              color: #01582B;
              margin-bottom: 10px;

              i {
                font-size: 20px;
              }
            }

            .qrcode-body {
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 140px;
              background: #fff;
              border-radius: 8px;
              padding: 8px;
              position: relative;

              .qrcode-image {
                width: 140px;
                height: 140px;
                object-fit: contain;
                cursor: pointer;
                transition: transform 0.3s ease;
                border-radius: 4px;

                &:hover {
                  transform: scale(1.04);
                  box-shadow: 0 4px 16px rgba(0, 104, 48, 0.15);
                }
              }

              .qrcode-placeholder {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 6px;
                color: #999;
                padding: 20px 0;

                i {
                  font-size: 40px;
                  color: #d0d8d0;
                }

                span {
                  font-size: 13px;
                }

                .el-button {
                  color: #01582B;
                  font-weight: 500;
                  &:hover {
                    color: #004d1f;
                  }
                }
              }

              // 覆盖 element-ui loading 样式，让它在二维码区域内居中
              .el-loading-mask {
                border-radius: 8px;
                background: rgba(255, 255, 255, 0.75);
              }
            }

            .qrcode-tip {
              text-align: center;
              margin-top: 8px;
              font-size: 13px;
              color: #888;

              span {
                display: inline-block;
                background: #eaf7ed;
                padding: 2px 14px;
                border-radius: 12px;
                color: #01582B;
                font-weight: 500;
              }
            }
          }

          .el-button--danger {
            background: #01582B;
            border-color: #01582B;
            &:hover {
              background: #005225;
              border-color: #005225;
            }
            &:disabled {
              background: #a0c0a8;
              border-color: #a0c0a8;
            }
          }
        }
      }
    }
  }
}

// ============================================================
// 购买弹窗
// ============================================================
.purchase-body {
  .purchase-goods {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e0eee3;
    .purchase-img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      margin-right: 16px;
      border-radius: 6px;
      border: 1px solid #d6e8db;
    }
    .purchase-name {
      font-weight: 500;
      color: #222;
    }
    .purchase-price {
      color: #01582B;
      font-size: 22px;
      font-weight: bold;
      &::before {
        content: "¥";
        font-size: 16px;
      }
    }
  }
  .spec-section {
    margin: 16px 0;
    .spec-title {
      font-weight: 500;
      margin-bottom: 10px;
      color: #333;
    }
    .el-radio-button__inner {
      border-radius: 4px;
      &:hover {
        color: #01582B;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #01582B;
      border-color: #01582B;
      box-shadow: -1px 0 0 0 #01582B;
    }
  }
  .min-order-tip {
    background: #eaf7ed;
    padding: 8px 16px;
    border-radius: 4px;
    margin: 12px 0;
    color: #01582B;
    font-size: 14px;
    i {
      margin-right: 6px;
    }
  }
  .quantity-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0;
    span {
      font-weight: 500;
      color: #333;
    }
  }
  .purchase-buttons {
    display: flex;
    gap: 12px;
    margin-top: 20px;
    .el-button {
      flex: 1;
      border-radius: 4px;
      font-weight: 500;
    }
    .el-button--primary {
      background: #fff;
      border-color: #01582B;
      color: #01582B;
      &:hover {
        background: #eaf7ed;
      }
    }
    .el-button--danger {
      background: #01582B;
      border-color: #01582B;
      &:hover {
        background: #005225;
        border-color: #005225;
      }
    }
  }
}
// ===== 二维码弹窗样式 =====
.qrcode-dialog {
  .el-dialog {
    border-radius: 12px;
    .el-dialog__body {
      padding: 20px 30px 30px;
    }
  }

  .qrcode-dialog-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcode-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 18px;
      font-weight: 600;
      color: #01582B;
      margin-bottom: 16px;

      i {
        font-size: 24px;
      }
    }

    .qrcode-image-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 200px;
      width: 100%;
      background: #fafcfa;
      border-radius: 8px;
      padding: 12px;
      border: 1px solid #e8f0ea;

      .qrcode-image {
        width: 200px;
        height: 200px;
        object-fit: contain;
        cursor: pointer;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.05);
        }
      }

      .qrcode-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        color: #999;

        i {
          font-size: 48px;
          color: #d0d8d0;
        }

        .el-button {
          color: #01582B;
          &:hover {
            color: #004d1f;
          }
        }
      }
    }

    .qrcode-tip {
      margin-top: 14px;
      font-size: 14px;
      color: #01582B;
      background: #eaf7ed;
      padding: 4px 20px;
      border-radius: 20px;
    }

    .qrcode-extra {
      margin-top: 10px;
      font-size: 12px;
      color: #aaa;
    }
  }
}

// ============================================================
// 响应式微调
// ============================================================
@media screen and (max-width: 768px) {
  .stats-cards-wrapper .stat-card {
    flex-direction: column;
    text-align: center;
    padding: 16px 12px;
    height: auto;
    min-height: 160px;
    .stat-icon {
      margin-right: 0;
      margin-bottom: 8px;
    }
  }
  .stats-cards-wrapper .stat-card-goods {
    height: auto;
    min-height: 200px;
    .goods-list .goods-item {
      flex: 0 0 100px;
      img {
        max-width: 80px;
      }
      .goods-name {
        font-size: 12px;
        max-width: 100px;
      }
      .goods-price {
        font-size: 14px;
      }
    }
  }
  .promo-cards-wrapper .promo-card {
    height: 140px;
    .promo-overlay {
      padding: 18px 20px;
      .promo-title {
        font-size: 18px;
      }
      .promo-desc {
        font-size: 12px;
      }
    }
  }
  .header .header-content {
    flex-wrap: wrap;
    .logo {
      margin-right: 20px;
    }
    .search-area {
      order: 3;
      flex: 1 1 100%;
      margin-top: 8px;
    }
    .cart-area {
      margin-left: auto;
    }
  }

  .goods-detail-dialog .detail-body .detail-layout {
    flex-direction: column;
    height: auto;
    max-height: 80vh;

    .detail-left {
      overflow-y: auto;
      max-height: 60vh;
      width: 100%;
    }

    .detail-right {
      flex: none;
      width: 100%;
      position: relative;
      border-left: none;
      border-top: 1px solid #e8f0ea;
      padding-left: 0;
      padding-top: 16px;
      max-height: none;
      overflow-y: visible;
    }

    .image-item.small-image {
      width: 48%;
      margin-right: 2%;
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
    .text-item .copy-hint {
      position: static;
      transform: none;
      opacity: 1;
      margin-top: 6px;
      display: inline-block;
    }

    .qrcode-module .qrcode-body .qrcode-image {
      width: 120px;
      height: 120px;
    }
  }
}
</style>
